import { render } from "./PublicStepFour.vue?vue&type=template&id=5100f595&scoped=true"
import script from "./PublicStepFour.vue?vue&type=script&lang=js"
export * from "./PublicStepFour.vue?vue&type=script&lang=js"

import "./PublicStepFour.vue?vue&type=style&index=0&id=5100f595&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5100f595"]])

export default __exports__